/* BaseLogger.js */

"use strict";
const defaultLogger = require("./util/defaultLogger");
class LogAdapter {
    constructor(logger = defaultLogger) {
        this._logger = logger;
    }
    debug(continuation, msg, depth, logEventInfo) {
        this._logger.debug(
            {
                continuation: continuation,
                logEventInfo: logEventInfo,
            },
            "__ " + "   ".repeat(depth) + msg
        );
    }
    warning(continuation, msg, depth, logEventInfo) {
        this._logger.warn(
            {
                continuation: continuation,
                logEventInfo: logEventInfo,
            },
            "!! " + "   ".repeat(depth) + msg
        );
    }
    info(continuation, msg, depth, logEventInfo) {
        this._logger.info(
            {
                continuation: continuation,
                logEventInfo: logEventInfo,
            },
            "   " + "   ".repeat(depth) + msg
        );
    }
    checkPoint(continuation, msg, depth, logEventInfo) {
        this._logger.info(
            {
                continuation: continuation,
                logEventInfo: logEventInfo,
            },
            "(*) " + "   ".repeat(depth) + msg
        );
    }
    taskStart(continuation, msg, depth, logEventInfo) {
        //add padding based on depth.
        this._logger.debug(
            {
                continuation: continuation,
                logEventInfo: logEventInfo,
            },
            ">> " + "   ".repeat(depth) + msg
        );
    }
    taskEnd(continuation, msg, depth, logEventInfo) {
        //add padding based on depth.
        this._logger.debug(
            {
                continuation: continuation,
                logEventInfo: logEventInfo,
            },
            "<< " + "   ".repeat(depth) + msg
        );
    }
    abort(continuation, msg, depth, logEventInfo) {
        this._logger.error(
            {
                continuation: continuation,
                logEventInfo: logEventInfo,
            },
            "xx " + "   ".repeat(depth) + msg
        );
    }
}
module.exports = LogAdapter;
